export type ReviewItem = {
  id: string;
  kicker: string;
  title: string;
  summary: string;
  author: string;
  tag: string;
  cover: string;
};

export const reviews: ReviewItem[] = [
  {
    id: "r1",
    kicker: "反转复盘 · 第 01 期",
    title: "风向两连变：一场反转是怎么一步步被评论区抬起来的",
    summary:
      "先有实锤，再有反证，最后来了波声明。我们把整场反转拆成四个阶段，复盘每一次情绪拐点背后对应的关键信息。",
    author: "复盘编辑部",
    tag: "舆论分析",
    cover:
      "https://readdy.ai/api/search-image?query=two%20opposing%20hands%20silhouettes%20reaching%20toward%20each%20other%20against%20a%20warm%20amber%20to%20deep%20charcoal%20gradient%2C%20dramatic%20side%20light%2C%20symbolic%20of%20shifting%20public%20opinion%20and%20reversal%2C%20no%20people%2C%20no%20text%2C%20abstract%20editorial%20composition&width=640&height=400&seq=review-01&orientation=landscape",
  },
  {
    id: "r2",
    kicker: "反转复盘 · 第 02 期",
    title: "为什么每次「实锤」到最后都容易被反转？三个常见陷阱",
    summary:
      "截图只看局部、切片掐头去尾、时间线没对齐——复盘过去半年的案例，真正站得住脚的实锤到底长什么样。",
    author: "理性吃瓜社",
    tag: "方法论",
    cover:
      "https://readdy.ai/api/search-image?query=three%20magnifying%20glasses%20of%20different%20sizes%20arranged%20in%20a%20row%20on%20a%20warm%20desk%20over%20newsprint%2C%20soft%20amber%20light%2C%20symbolic%20of%20careful%20evidence%20review%20and%20logical%20thinking%2C%20no%20people%2C%20no%20text%2C%20editorial%20minimal%20composition&width=640&height=400&seq=review-02&orientation=landscape",
  },
  {
    id: "r3",
    kicker: "反转复盘 · 第 03 期",
    title: "一次成功澄清的样本：真反证是如何让风向一天之内倒转的",
    summary:
      "记录一次相对干净的澄清全过程：当事方放出的反证为什么能被快速接受，而另一起案例却越洗越黑，差别到底在哪。",
    author: "复盘编辑部",
    tag: "案例拆解",
    cover:
      "https://readdy.ai/api/search-image?query=a%20clear%20glass%20bottle%20with%20light%20passing%20through%20creating%20warm%20highlights%20on%20a%20dark%20background%2C%20amber%20and%20vermillion%20tones%2C%20symbolic%20of%20clarity%20and%20clarification%20after%20confusion%2C%20no%20people%2C%20no%20text%2C%20clean%20abstract%20editorial%20composition&width=640&height=400&seq=review-03&orientation=landscape",
  },
];

export type FollowUpItem = {
  id: string;
  title: string;
  time: string;
  summary: string;
  status: string;
  statusTone: string;
};

export const followUps: FollowUpItem[] = [
  {
    id: "f1",
    title: "品牌方公告：即日解除与涉事方的合作关系",
    time: "2 小时前",
    summary: "品牌方用一句公告切断关联，通常被视作事件定性的强信号。完整措辞与解读见声明拆解区。",
    status: "新进展",
    statusTone: "primary",
  },
  {
    id: "f2",
    title: "相关综艺片段连夜下架，仅保留可公开切片",
    time: "5 小时前",
    summary: "平台侧动作常被纳入后续进展观察，我们把下架清单与时间点一并记录进时间线。",
    status: "持续发酵",
    statusTone: "accent",
  },
  {
    id: "f3",
    title: "涉事方账号批量清理历史动态，评论区争论未停",
    time: "昨天",
    summary: "删改动态本身不构成证据，但放在完整时间线里，往往与事件走向互相印证。",
    status: "观察中",
    statusTone: "secondary",
  },
  {
    id: "f4",
    title: "新一轮实锤帖补充上线，证据链持续加长",
    time: "昨天",
    summary: "实锤讨论区新增三帖，建议结合归档时间线一起阅读，避免只盯单条截图下结论。",
    status: "讨论升级",
    statusTone: "primary",
  },
  {
    id: "f5",
    title: "复盘编辑部预告：完整反转复盘将于本周四发布",
    time: "2 天前",
    summary: "届时会把整起事件的前因后果与各阶段证据串成一篇完整复盘，欢迎届时对照时间线核验。",
    status: "即将发布",
    statusTone: "secondary",
  },
];